import type { Track } from "@similarweb/tracking-provider";

import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";

const CATEGORY = "Signal Recommender";

export const createSignalRecommenderTrackingService = (track: Track) => {
    const trackEvent = (action: string, eventName: string, eventSubName: string) => {
        track(CATEGORY, action, createTrackingEventName(eventName, eventSubName));
    };

    return {
        trackOpenUploadModal() {
            trackEvent("click", "Upload CSV", "Open modal");
        },

        trackCloseUploadModal() {
            trackEvent("click", "Upload CSV", "Close modal");
        },

        trackRetryHistory() {
            trackEvent("click", "Enrichment history", "Retry");
        },

        trackRefreshFileStatus() {
            trackEvent("click", "Refresh", "Stalled run");
        },

        /** Fires once the picked file has been read, so the outcome is known. */
        trackFileValidated(isValid: boolean, companiesCount: number) {
            trackEvent("select file", "File validation", isValid ? `valid/${companiesCount} companies` : "invalid");
        },

        /** Counts, not names: which taxonomy nodes an account filters by is customer data. */
        trackEnrichmentSubmit(intentFiltersCount: number, technologyFiltersCount: number) {
            trackEvent(
                "click",
                "Enrich and download",
                `intent:${intentFiltersCount}/technology:${technologyFiltersCount}`,
            );
        },

        trackEnrichmentUploaded(acceptedRowsCount: number, skippedRowsCount: number) {
            trackEvent("upload", "Enrichment request", `accepted:${acceptedRowsCount}/skipped:${skippedRowsCount}`);
        },

        trackEnrichmentUploadFailed() {
            trackEvent("upload", "Enrichment request", "failed");
        },

        trackDownloadFile() {
            trackEvent("click", "Download", "Enriched file");
        },
    };
};
